import { useQuery } from 'react-apollo';
import uniqBy from 'lodash.uniqby';

import { AlbumFolderForWebGalleryPurchasedPhotoDownloads } from '../../../graphql/queries/album-folder';

const getPhotoIdsFromAlbum = album => {
  if (!album?.purchased_photo_downloads) {
    return [];
  }

  return album.purchased_photo_downloads.records.map(({ photo }) => photo.id);
};

const getPhotoIdsFromAlbumFolder = albumFolder => {
  if (!albumFolder?.children?.albums) {
    return [];
  }

  return (albumFolder.children.albums.records ?? []).reduce(
    (photoIds, album) => [...photoIds, ...getPhotoIdsFromAlbum(album)],
    [],
  );
};

const useAlbumFolderForWebGalleryPurchasedPhotoDownloads = ({
  albumFolderId,
  isFreeWebGallery,
}) => {
  const { data: { albumFolder } = {} } = useQuery(
    AlbumFolderForWebGalleryPurchasedPhotoDownloads,
    {
      variables: { id: albumFolderId },
      skip: !albumFolderId || !isFreeWebGallery,
      fetchPolicy: 'cache-and-network',
    },
  );

  const { children: { album_folders: folders = {} } = {} } = albumFolder ?? {};
  const unfilteredPurchasedPhotoDownloads =
    folders?.total > 0
      ? folders.records.reduce((photoIds, folder) => {
          return [...photoIds, getPhotoIdsFromAlbumFolder(folder)];
        }, [])
      : getPhotoIdsFromAlbumFolder(albumFolder);

  return {
    purchasedPhotoDownloads: uniqBy(unfilteredPurchasedPhotoDownloads),
  };
};

export default useAlbumFolderForWebGalleryPurchasedPhotoDownloads;
